import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum TaskTimeAnchorId {
  RESERVATION = 'reservation',
  SERVICE = 'service',
}

export class TaskTimeAnchor extends Codebook<TaskTimeAnchorId> {
  static readonly RESERVATION = new TaskTimeAnchor(
    TaskTimeAnchorId.RESERVATION,
    () => $t('taskTimeAnchor.reservation'),
    () => $t('taskTimeAnchor.reservation.instrumental'),
  )

  static readonly SERVICE = new TaskTimeAnchor(
    TaskTimeAnchorId.SERVICE,
    () => $t('taskTimeAnchor.service'),
    () => $t('taskTimeAnchor.service.instrumental'),
  )

  private constructor(
    id: TaskTimeAnchorId,
    public readonly name: () => string,
    public readonly nameInstrumental: () => string,
  ) {
    super(id)
  }
}
